<template>
  <canvas></canvas>
</template>

<script>
import {
  BarController,
  BarElement,
  CategoryScale,
  Chart,
  LinearScale,
} from 'chart.js'

Chart.register(BarElement, BarController, CategoryScale, LinearScale)

export default {
  props: {
     labels: {
      required: true,
      type: Array,
    },
    datasets: {
      required: true,
      type: Array,
    },
  },

  mounted() {
    this.elem = jQuery(this.$el)

    this._iniChart()
  },
  methods: {
    _iniChart: function () {
     if (this.labels === null || this.datasets === null) {
        return
      }

      const chartDatasets = this.datasets

      chartDatasets.forEach((dataset) => {
        dataset.borderRadius = 12
      })

      const ctx = this.elem[0].getContext('2d')

      this.chart = new Chart(ctx, {
        type: 'bar',
        data: {
          labels: this.labels,
          datasets: chartDatasets,
        },
        options: {
          scales: {
            x: {
              // beginAtZero: true,
              grid: {
                display: false,
              },
            },
            y: {
              border: {
                dash: [2, 4],
              },
            },
          },
          plugins: {
            legend: {
              display: false,
            },
              tooltip: {
              intersect: false,
              backgroundColor: '#fff',
              padding: 8,            
              bodyFont: {
                family: 'AeonikPro ,  sans-serif',
                size: 14,
                weight: 700,
              },
              bodyColor: '#5B6069',
              displayColors: false,
              callbacks: {               
                label: function (context) {
                  return `${context.formattedValue}%`
                },
                 title : () => null
              },
            },
          },
        },
      })
    },
  },
}
</script>
